import React from "react";

import NavBottomBar from "../../Components/Common/NavBottomBar";
import LodgingPackageCalendar from "./calendar";
import MobileViewContainer from "../../Components/MobileViewContainer";

const LodgingPackagePage = () => {

    return (
        <MobileViewContainer>
            <div className="px-4">
                <LodgingPackageCalendar />
            </div>

            <NavBottomBar activeBar={6} />
        </MobileViewContainer>
    );
};

export default LodgingPackagePage;
